import React from "react";

const BankSelector = ({ value, onChange }) => {
  const banks = [
    { name: "Access Bank", code: "044" },
    { name: "Citibank", code: "023" },
    { name: "Ecobank Nigeria", code: "050" },
    { name: "Fidelity Bank", code: "070" },
    { name: "First Bank of Nigeria", code: "011" },
    { name: "First City Monument Bank", code: "214" },
    { name: "Guaranty Trust Bank", code: "058" },
    { name: "Heritage Bank", code: "030" },
    { name: "Keystone Bank", code: "082" },
    { name: "Polaris Bank", code: "076" },
    { name: "Providus Bank", code: "101" },
    { name: "Stanbic IBTC Bank", code: "221" },
    { name: "Standard Chartered Bank", code: "068" },
    { name: "Sterling Bank", code: "232" },
    { name: "Suntrust Bank", code: "100" },
    { name: "Union Bank of Nigeria", code: "032" },
    { name: "United Bank For Africa", code: "033" },
    { name: "Unity Bank", code: "215" },
    { name: "Wema Bank", code: "035" },
    { name: "Zenith Bank", code: "057" },
    { name: "Kuda Bank", code: "50211" },
    { name: "Opay", code: "999991" },
    { name: "Palmpay", code: "999992" },
    { name: "Moniepoint Microfinance Bank", code: "50515" },
    { name: "Carbon", code: "565" },
    { name: "Rubies MFB", code: "125" },
    { name: "VFD Microfinance Bank", code: "566" },
  ];

  return (
    <select
      value={value ? `${value.bankName}|${value.bankCode}` : ""}
      onChange={(e) => {
        const [name, code] = e.target.value.split("|");
        onChange({ bankName: name, bankCode: code });
      }}
      name="bankName"
      className="w-full mb-3 px-4 py-2 rounded bg-transparent border border-white/20 text-white"
    >
      <option value="" className="text-black">
        Select Bank
      </option>
      {banks.map((bank) => (
        <option key={bank.code} value={`${bank.name}|${bank.code}`} className="text-black">
          {bank.name}
        </option>
      ))}
    </select>

  );
};

export default BankSelector;